import { createFileRoute } from "@tanstack/react-router"
import { uomLoader } from "shared/loaders"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { WarehouseReceivingLayout } from "@/screens/WarehouseReceiving/components"

export const Route = createFileRoute("/app/warehouse-receiving/_layout")({
  loader: uomLoader,
  staleTime: Infinity,
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.WAREHOUSE_RECEIVING_VIEW]}>
      <WarehouseReceivingLayout />
    </PermissionContentWrapper>
  ),
})
